import { AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import useSWR from 'swr'

import { apiFetcher } from '@/data/fetcher'
import { EetStatus } from '@invo.space/shared'

export function EetWarningBanner() {
  const { t } = useTranslation(undefined, { keyPrefix: 'cashRegister.eet.warning' })
  const { data } = useSWR<EetStatus>('/api/v2/eet', apiFetcher)

  if (!data?.deadlineWarning) {
    return null
  }

  return (
    <div role="status" className="mb-4 flex items-start gap-3 rounded-lg bg-warning-bg px-4 py-3 text-sm text-warning">
      <AlertTriangle className="mt-0.5 size-4 shrink-0" aria-hidden />
      <div className="min-w-0">
        <p className="font-medium">{t('title')}</p>
        <Link to="/cash-register/settings" className="underline underline-offset-2">
          {t('description')}
        </Link>
      </div>
    </div>
  )
}
